const routes = [

  {
    path: '/',
    component: () => import('layouts/Public.vue'),
    children: [
      {
        path: '',
        name: 'IndexView',
        component: () => import('../views/Index.vue'),
        meta: { requiresAuth: true }
      },
    ]
  },

  // AUTH
  {
    path: "/auth",
    component: () => import("layouts/Public.vue"),
    children: [
      {
        path: "",
        name: "AuthIndex",
        component: () => import("base/BaseAuthIndex.vue"),
        meta: { requiresAuth: false },
        props: route => ({ query: route.query.q })
      },
    ],
  },

  // CUSTOMER 
  {
    path: '/customers',
    component: () => import('layouts/Main.vue'),
    children: [
      {
        path: '',
        name: 'customer',
        component: () => import('views/customers/Index.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/settings',
        name: 'customer_settings',
        component: () => import('views/customers/Settings.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/detail',
        name: 'customer_detail',
        component: () => import('views/customers/Detail.vue'),
        meta: { requiresAuth: true },
        props: route => ({ query: route.query.q })
      },
      {
        path: '/list',
        name: 'customers_list',
        component: () => import('views/customers/List.vue'),
        meta: { requiresAuth: true },
      },
    ]
  },


  // ERROR
  {
    path: '/error',
    component: () => import('layouts/Public.vue'),
    children: [
      {
        path: 'init-error',
        name: 'InitError',
        component: () => import("views/error/InitError.vue"),
        meta: { requiresAuth: false },
        props: true
      },
    ]
  },

  {
    path: '*',
    name: 'error404',
    component: () => import("views/error/Error404.vue"),
    // component: () => import(/* webpackChunkName: "error404" */ 'base/BaseError404.vue'),
    meta: { requiresAuth: false }
  },


]


export default routes
